module.exports = __webpack_public_path__ + "static/img/newOne.d4c972a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newOne.png
// module id = Xxro
// module chunks = 1